import { CONTAINER } from "../tokens";

// Bande « Déjà accompagnés » du handoff. Un emplacement sans image garde le
// motif hachuré de la maquette — c'est exactement le statut que le handoff
// leur donne (placeholders à remplacer par les vrais logos), et ça laisse
// l'admin voir combien d'emplacements il a à remplir.
const HATCH = {
  backgroundImage:
    "repeating-linear-gradient(135deg, rgb(var(--c-ink, 22 21 15) / 0.09) 0 2px, transparent 2px 10px)",
};

export default function ClientLogosSection({ props = {}, blocks = [] }) {
  const items = (blocks || []).filter((b) => b.type === "logo_item" && b.enabled !== false);
  if (!items.length) return null;

  return (
    <section className="border-y border-ink/[0.09]">
      <div className={`${CONTAINER} py-5 flex flex-wrap items-center gap-x-9 gap-y-4`}>
        {props.label && (
          <span className="font-display text-[12px] uppercase tracking-[0.1em] text-ink/40">
            {props.label}
          </span>
        )}
        <div className="flex flex-wrap gap-3 flex-1 min-w-[240px]">
          {items.map((b) =>
            b.props?.image_url ? (
              <img
                key={b.id}
                data-block-key={b.id}
                src={b.props.image_url}
                alt={b.props.alt || ""}
                className="h-7 w-auto max-w-[160px] object-contain flex-1 min-w-[92px] grayscale opacity-70"
              />
            ) : (
              <div
                key={b.id}
                data-block-key={b.id}
                className="flex-1 min-w-[92px] h-7 rounded-md"
                style={HATCH}
              />
            )
          )}
        </div>
      </div>
    </section>
  );
}
